var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { deepMergeObj } from 'src/shared/helpers/objHelpers';
export var mergeMoConfigs = function (systemConf, orgConf) {
    // We only merge specific attributes for now
    var externalDataFetching = deepMergeObj((systemConf === null || systemConf === void 0 ? void 0 : systemConf.externalDataFetching) || {}, (orgConf === null || orgConf === void 0 ? void 0 : orgConf.externalDataFetching) || {});
    var systemSearchConf = (systemConf === null || systemConf === void 0 ? void 0 : systemConf.search) || {};
    var orgSearchConf = (orgConf === null || orgConf === void 0 ? void 0 : orgConf.search) || {};
    var filterPresets = deepMergeObj(systemSearchConf.filterPresets || {}, orgSearchConf.filterPresets || {});
    var autoPlay = deepMergeObj((systemConf === null || systemConf === void 0 ? void 0 : systemConf.autoPlay) || {}, (orgConf === null || orgConf === void 0 ? void 0 : orgConf.autoPlay) || {});
    return __assign(__assign({}, orgConf), { externalDataFetching: externalDataFetching, search: __assign(__assign({}, orgSearchConf), { filterPresets: filterPresets }), autoPlay: autoPlay });
};
